import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/zeroVisitsSagas";

const PeriodType = () => {
  const dispatch = useDispatch();
  const {
    periodTypeOptions,
    selectedFilters: { period_type }
  } = useSelector((state) => state.zeroVisits);

  return (
    <MultiSelectDropdown
      options={periodTypeOptions}
      selectedFilters={period_type}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updatePeriodType(data))}
    />
  );
};
export default PeriodType;
